import React from "react";
import {Toaster} from "../shared/Toaster/Toaster";
import {ApolloProvider} from "../ApolloProvider/ApolloProvider";
import {BrowserRouter} from "react-router-dom";
import AppLayout from "./AppLayout/AppLayout";

export const Layout:React.FunctionComponent<any> = () => {
  return (
    <ApolloProvider>
      <Toaster>
        <BrowserRouter>
          <AppLayout />
        </BrowserRouter>
      </Toaster>
    </ApolloProvider>
  )
}

export default Layout;